import React, { useState, useRef, useLayoutEffect } from "react"
import StyledCustomInput from './style'

const CustomInput = (
  {
    onInput = "",
    id = "",
    label = "",
    name = "",
    validations = [],
    labelClassName = "",
    inputClassName = "",
    spanClassName = "",
    ...otherProps
  } = {}
) => {


  const labelClassNames = [`custom-input__label ${labelClassName}`]
  const inputClassNames = [`custom-input__input ${inputClassName}`]
  const spanClassNames = [`custom-input__span ${spanClassName}`]
  const spanId = `input-${id}-messages`

  const [message, setMessage] = useState()
  
  const handleInput = event => {
    const results = [...validations].map(validator => validator(event.target.value))
    const errors = results.filter(result => typeof result === "string")
    onInput(event)
    if (errors.length) {
      setMessage(errors[0])
    } else if (message) {
      setMessage('')
    }
  }
  
  const customInputRef = useRef()

  useLayoutEffect(() => {
    const { current } = customInputRef
    if (current && message) {
      current.classList.add("custom-input--error")
    } else {
      current.classList.remove("custom-input--error")
    }
  }, [message])


  return (
    <StyledCustomInput ref={customInputRef}>

      <label
        className={labelClassNames}
        htmlFor={id}
      >{label}</label>
      <input
        name={name || id}
        className={inputClassNames}
        value={otherProps.value}
        id={id}
        onInput={handleInput}
        {...otherProps}
      />
      <span
        className={spanClassNames}
        id={spanId}
        aria-live="polite"
      >{message}</span>

    </StyledCustomInput>
  )
}

export default CustomInput